import api from 'data/api';

export const loadBusinessPartners = api(
  'GET /api/mobile/finance/lookups/businesspartners'
);
